<template>
  <div class="spinner__holder"
       :class="{ 'spinner__holder--show': show }">
      <svg class="spinner__item"
           viewBox="0 0 46 46"
           xmlns="http://www.w3.org/2000/svg">
          <circle class="spinner__item-path"
                  fill="none"
                  stroke-width="4"
                  stroke-linecap="round"
                  cx="23" cy="23" r="20"></circle>
      </svg>
  </div>
</template>

<script>

  export default {
    name: 'spinner',
    props: {
      show: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="less">
    @import "../../less/variables.less";
</style>



// WEBPACK FOOTER //
// src/components/spinner/Spinner.vue